import script from "./menubarES.vue?vue&type=script&lang=js"
export * from "./menubarES.vue?vue&type=script&lang=js"

import "./menubarES.vue?vue&type=style&index=0&id=106fc972&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-106fc972"]])

export default __exports__